import FormSwiftAPIClient from 'FormSwiftAPI/FormSwiftAPIClient';
import { StaticSessionEmailEnum } from './SessionEmailConstants';

const uuidV4 = require('uuid/v4');

const formSwiftAPIClient = new FormSwiftAPIClient(window.API_URL);

export const openEmailModal = () => (
  (dispatch) => {
    dispatch({
      type: StaticSessionEmailEnum.STATIC_BUILDER_EMAIL_MODAL_OPEN,
    });
  }
);

export const closeEmailModal = () => (
  (dispatch) => {
    dispatch({
      type: StaticSessionEmailEnum.STATIC_BUILDER_EMAIL_MODAL_CLOSE,
    });
  }
);

export const sendSessionLinkEmail = (
  sessionId,
  sessionHash,
  documentType,
  emailTo,
  successCallback,
) => (
  async (dispatch) => {
    dispatch({
      type: StaticSessionEmailEnum.STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_REQUEST,
    });

    try {
      const payload = {
        document_type: documentType,
        email_to: emailTo,
        session_hash: sessionHash,
        version: uuidV4(),
      };

      await formSwiftAPIClient.request('POST', `/email/send-session-link/${sessionId}`, payload);

      dispatch({
        type: StaticSessionEmailEnum.STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_SUCCESS,
      });

      successCallback();
    } catch (e) {
      dispatch({
        type: StaticSessionEmailEnum.STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_FAILURE,
        error: e.message,
      });
    }
  }
);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/SessionEmail/SessionEmailActions.jsx